import Body from './Body/Body';
import { MODAL_CONTROL_ACTIONS } from 'src/utils/enums/user-store-actions.enum';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    ADD_NEW_USER_MODAL_CONTENT,
    ADD_NEW_USER_MODAL_LABEL_BUTTON_CANCEL,
    ADD_NEW_USER_MODAL_LABEL_BUTTON_CONFIRM,
    ADD_NEW_USER_MODAL_TITLE,
} from 'src/localization/resouceKeys';
import React, { Dispatch, SetStateAction, useEffect } from 'react';

import './styles.scss';

interface IUserManagementProps {
    setSuccessNotification: Dispatch<SetStateAction<boolean>>;
    setErrorNotification: Dispatch<SetStateAction<boolean>>;
    setSuccessNotificationMessage: Dispatch<SetStateAction<string>>;
    setErrorNotificationMessage: Dispatch<SetStateAction<string>>;
    setIsSuccessDeleted: Dispatch<SetStateAction<boolean>>;
    regions: Array<any>;
    districts: Array<any>;
    isEditMode: boolean;
    isLoadingDistAndReg: boolean;
}

const UserManagement: React.FC<IUserManagementProps> = ({
    setSuccessNotification,
    setErrorNotification,
    setSuccessNotificationMessage,
    setErrorNotificationMessage,
    setIsSuccessDeleted,
    regions,
    districts,
    isEditMode = false,
    isLoadingDistAndReg = false,
}) => {
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();

    const handleActiveModal = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_ACTIVE,
            payload: {
                titleContent: t(ADD_NEW_USER_MODAL_TITLE),
                bodyContent: t(ADD_NEW_USER_MODAL_CONTENT),
                cancelBtnLabel: t(ADD_NEW_USER_MODAL_LABEL_BUTTON_CANCEL),
                confirmBtnLabel: t(ADD_NEW_USER_MODAL_LABEL_BUTTON_CONFIRM),
                onCancelHandler: cancelhandler,
                onConfirmHandler: confirmHandler,
            },
        });
    };

    useEffect(() => {
        handleActiveModal();
    }, []);

    useEffect(() => {
        i18n.on('languageChanged', handleActiveModal);

        return () => {
            i18n.off('languageChanged', handleActiveModal);
        };
    }, []);

    const cancelhandler = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_SHOW,
            payload: { shouldShow: false },
        });
    };

    const confirmHandler = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_INACTIVE,
        });
    };

    return (
        <div className={'field-user-container'}>
            <Body
                setSuccessNotification={setSuccessNotification}
                setErrorNotification={setErrorNotification}
                setSuccessNotificationMessage={setSuccessNotificationMessage}
                setErrorNotificationMessage={setErrorNotificationMessage}
                setIsSuccessDeleted={setIsSuccessDeleted}
                regions={regions}
                districts={districts}
                isLoadingDistAndReg={isLoadingDistAndReg}
                isEditMode={isEditMode}
            />
        </div>
    );
};

export default UserManagement;
